// custom-actions.service.ts
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MailToService {

  constructor() {
  }

  mailTo(node: any) {
    let origin: string = window.location.origin;

    // Vérifiez si l'application est en local ou sur un serveur distant
    if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
      // Sur un serveur distant, ajoutez le premier élément après le premier slash à l'origin
      const pathParts = window.location.pathname.split('/');
      if (pathParts.length > 1) {
        origin += '/' + pathParts[1];
      }
    }

    // Construisez l'URL complète avec le chemin de l'URL
    let url = origin + '/#/libraries/' + node.parentId + '/(viewer:view/' + node.id + ')';

    // Construisez le lien mailto
    let mailto = 'mailto:?subject=' + node.name + '&body=' + url;

    // Ouvrez le lien dans un nouvel onglet
    window.open(mailto, '_blank');
  }


}

// http://localhost:4200/aca/#/personal-files
